// Brand tokens — faithful to the original Prompt Savant design
export const G = {
  gold: "#C9A84C",
  goldLight: "#E8C96A",
  goldDim: "#8a6f2e",
  goldGhost: "#C9A84C18",
  black: "#060606",
  dark: "#0c0b08",
  panel: "#111009",
  border: "#6a5832",
  borderHot: "#937e3a",
  creme: "#f0e8d5",
  cremeDark: "#e8dcc4",
  orange: "#FF6B1A",
  orangeDim: "#FF6B1A33",
  text: "#ede2c2",
  muted: "#b09e6a",
  ghost: "#ffffff08",
  tier: "#1c160d",
};

export const TIERS = [
  {
    id: "free", name: "Prompt Savant", sub: "FREE FOREVER", price: "$0",
    priceSub: "NO CARD REQUIRED", accent: G.gold, badge: null, prompts: 50,
    desc: "50 hand-selected prompts across all 50 genres. The perfect starting point.",
    features: [
      "50 prompts across all 50 genres",
      "1 prompt per genre sampled",
      "Full prompt quality — no watermarks",
      "Browse free, no login required",
      "Plug-in compatible with VP I/O (Coming Soon)",
    ],
    cta: "Start Free", outline: true,
  },
  {
    id: "vault", name: "Prompt Savant Vault", sub: "UPGRADE · TIER 1", price: "$19.99",
    priceSub: "ONE-TIME + 6.5% NC TAX", accent: G.gold, badge: null, prompts: 2050,
    desc: "2,050 prompts drawn from the full codex — 40 per genre, every style covered.",
    features: [
      "2,050 prompts (40 per genre)",
      "All 50 genres fully represented",
      "In-app AI prompt editing unlocked",
      "500 bundled credits included",
      "Instant access · Lifetime license",
      "All 6 variation types included",
    ],
    cta: "Get The Vault", outline: false,
  },
  {
    id: "codex", name: "Prompt Savant Codex", sub: "UPGRADE · TIER 2", price: "$59.99",
    priceSub: "ONE-TIME + 6.5% NC TAX", accent: G.orange, badge: "COMPLETE", prompts: 10050,
    desc: "The entire VP I/O Prompt Codex. All 10,050 prompts. Includes everything in Vault.",
    features: [
      "Full 10,050-prompt Codex (includes Vault)",
      "All 50 genres · 200 variations each",
      "In-app AI prompt editing unlocked",
      "2,000 bundled credits included",
      "Lifetime access · All future updates",
      "Priority VP I/O plug-in integration",
    ],
    cta: "Get The Codex", outline: false,
  },
];

export const HOW = [
  { n: "01", t: "Start Free", d: "Access 50 real codex-grade prompts instantly. No card. No signup friction. Just open and go." },
  { n: "02", t: "Pick Your Genre", d: "Browse all 50 genres. Filter by variation type. Find the exact prompt architecture you need." },
  { n: "03", t: "Copy & Generate", d: "Paste into Suno, Udio, or any AI music platform. Watch the prompt do exactly what it was built to do." },
  { n: "04", t: "Upgrade Anytime", d: "Ready for more? Vault unlocks 2,050 prompts. Codex unlocks all 10,050. One-time. Yours forever." },
];

export const FAQ = [
  { q: "What AI music platforms do these prompts work with?", a: "Prompt Savant prompts are optimized for all major AI music generation platforms including Suno, Udio, and others. The Tagged Modular format is particularly effective across platforms." },
  { q: "What's the difference between the tiers?", a: "All tiers access the same codex-grade library at different depths. Free gets 1 prompt per genre (50 total). Vault gets 40 per genre (2,050 total). Codex gets all 200 per genre (10,050 total) — and includes everything in Vault." },
  { q: "Are these one-time purchases?", a: "Yes. Both the Vault ($19.99) and Codex ($59.99) are one-time purchases plus 6.5% NC tax. Pay once, access yours forever. No subscriptions." },
  { q: "How do credits work?", a: "Each paid tier includes bundled credits. Opening a premium prompt costs 5 credits the first time — reopening it later is always free. AI editing a prompt costs 10 credits the first time, 5 each time after." },
  { q: "Do I need to create an account?", a: "No account is needed to browse the free tier. You sign in with a one-tap email magic link only when you upgrade, open premium prompts, or use AI editing." },
];
